import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators'
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";
import { ConfiguracionVozService } from "./configuracion-voz.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';

import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_voice } from 'app/idiomas/i18n/configuracion-voz/voice.lang';

@Component({
  selector: 'app-configuracion-voz',
  templateUrl: './configuracion-voz.component.html',
  styleUrls: ['./configuracion-voz.component.scss']
})
export class ConfiguracionVozComponent implements OnInit {

  audiosActivos: boolean;
  surveyProduct: any;
  listaVocesSel: any = [];
  textoDemo: string;
  idiomas: any = [];
  catVocesProd: any = {};

  valoresForm: any = {};

  cadenaB64:string;
  url:any;
  guardandoTemplate: boolean;

  //boolean paso completo
  pasoCompleto = false;
  //boolean cargando
  cargando = true;
  validationUser: boolean;
  validationSurvey: boolean;
  desbloqueoEstatus: boolean;

  constructor(
    private confVozService: ConfiguracionVozService,
    private surveyProductService: SurveyProductService,
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_voice.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    if(localStorage.getItem('userBypass')){
      const userData:any = JSON.parse(localStorage.getItem('userBypass'));
      if(userData.level==3 || userData.level==2){
        this.validationUser = true;
      }
      else{
        this.validationUser = false;
      }
    }
  }

  ngOnInit(): void {
    this.getIdiomasElegidos();
    this.surveyProductService.enviaDatosASurvProd({ recuperaInformacion: true });
    this.recibeDatosSP();
    this.statusPaso();
  }

  statusPaso(){
    this.confVozService.getStatusPaso(localStorage.getItem('productoID')).subscribe( (data: any) => {
      if(data.estatus === 3)
        this.pasoCompleto = true;
    });
  }

  getStatusEncuesta(token:any){
    if(token){
      this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
        if(data.result.id_status == 1){
          this.validationSurvey = true;
        }
        else{
          this.validationSurvey = false;
        }
      });
    }
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(localStorage.getItem('productoID')).subscribe((respuesta:any) => {
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus = true;
      }
      else{
        this.desbloqueoEstatus = false;
      }
    });
  }

  getIdiomasElegidos(){
    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.confVozService.getIdiomasProd(datos).subscribe( (respuesta: any) => {
      // console.log("getIdiomasProd:",respuesta);
      respuesta.idiomasMostrar.sort( (a,b) => {
        if(parseInt(a.tipoIdioma) < parseInt(b.tipoIdioma)){ return 1; } else{ return -1; }
      });
      respuesta.idiomasMostrar.forEach(idioma => {
        if((idioma.tipoIdioma == '0' || idioma.tipoIdioma == '1') && idioma.vivoIdioma == 1){
          this.idiomas.push(idioma);
          this.valoresForm[idioma.nombreIdioma] = {
            genero: '',
            tipoVoz: ''
          };
        }
      });
      console.log("idiomas:",this.idiomas);
      console.log("valoresForm:",this.valoresForm);
      this.getVoices();
    });
  }

  recibeDatosSP(){
    this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
      console.log("---------------------------DATOS RECIBIDOS :V ----------------------------");
      console.log(datos);
      if(datos.recuperaInformacion == true){
        this.surveyProduct = datos.surveyProduct;
        this.getStatusEncuesta(datos.productoCertificar.tokenConfig);
        this.getEstatusDesbloqueo();
      }
      if(datos.actualizarProducto == true){
        this.guardandoTemplate = false;
      }
    });
  }

  getVoices(){
    this.confVozService.getVoices().subscribe((respuesta:any) => {
      // console.log("getVoices:",respuesta);
      if(respuesta.success){
        // this.catVoces = respuesta.languages;
        respuesta.languages.forEach(idioma => {
          if(!this.catVocesProd[idioma.claveIdioma]){
            this.catVocesProd[idioma.claveIdioma] = idioma;
          }
        });
        console.log("catVoces:",this.catVocesProd);
        this.getFormVoices();
      }
    });
  }

  getFormVoices(){
    this.confVozService.getFormVoices().subscribe((respuesta:any) => {
      console.log("getFormVoices:",respuesta);
      this.cargando = false;
      let primerIdioma:boolean;
      for (let clave in this.valoresForm) {
        const datosIdioma = respuesta.voices.find(item => item.claveIdioma == clave);
        if(datosIdioma != undefined){
          if(datosIdioma.gender != ""){
            this.valoresForm[clave].genero = datosIdioma.gender;
            if(datosIdioma.nameVoice != ""){
              if(!primerIdioma){
                primerIdioma = true;
                const objCatVoces:any = this.catVocesProd[clave];
                const objCatGenders:any = objCatVoces.genders.find(item => item.gender == datosIdioma.gender);
                this.eligeGenero(objCatGenders);
              }
              this.valoresForm[clave].tipoVoz = datosIdioma.nameVoice;
            }
          }
        }
      }
    });
  }

  setStatusAudios(){
    console.log("cambio status:",this.surveyProduct);
    this.guardandoTemplate = true;
    this.surveyProduct.broker= parseInt(localStorage.getItem('instituto_id'));
    this.confVozService.setSeccionesCuestionario(this.surveyProduct._id,this.surveyProduct).subscribe((respuesta:any) => {
      console.log("actualizaCuestionario:",respuesta);
      this.guardandoTemplate = false;
    });
  }

  testStep(evt:any){
    console.log("cambioStep:",evt);
    const claveIdioma = this.idiomas[evt.selectedIndex].nombreIdioma;
    const objCatVoces:any = this.catVocesProd[claveIdioma];
    const objCatGenders:any = objCatVoces.genders.find(item => item.gender == this.valoresForm[claveIdioma].genero);
    this.eligeGenero(objCatGenders);
  }

  eligeGenero(evt:any){
    this.listaVocesSel = evt.voices;
  }
  eligeVoz(evt:any, claveIdioma:string){
    console.log("vozElegida:",evt);
    // console.log("valoresForm:",this.valoresForm);
    let datos = {
      productoId: localStorage.getItem('productoID'),
      claveIdioma,
      gender: this.valoresForm[claveIdioma].genero,
      typeVoice: this.valoresForm[claveIdioma].tipoVoz,
      languageCode: evt.languageCode
    };
    console.log(`datos voz ${claveIdioma}: `,datos);
    this.guardandoTemplate = true;
    this.confVozService.saveFormVoices(datos).subscribe((respuesta:any) => {
      console.log("saveFormVoices:",respuesta);
      if(respuesta.success){
        ///pasa algo
        this.guardandoTemplate = false;
      }
    });
  }

  tts(texto:string, claveIdioma:string){
    this.confVozService.generaAudioPregunta({texto, claveIdioma, productoId: localStorage.getItem('productoID')}).subscribe((respuesta:any) => {
      console.log("generaAudioPregunta:",respuesta);
      if(respuesta.success){
        this.DEMO_convierteAudioBlob(respuesta.response.audioContent);
      }
    });
  }

  DEMO_convierteAudioBlob(cadenaB64:string){
    this.cadenaB64 = cadenaB64;
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = cadenaB64;

    const blob = b64toBlob(b64Data, contentType);
    this.url = URL.createObjectURL(blob);
    console.log("urlAudio:",this.url);
    var audio = new Audio(this.url);
    audio.play();
  }

  saveFormVoices(){
    let datos = {
      productoId: localStorage.getItem('productoID'),
      claveIdioma: '',
      gender: '',
      typeVoice: '',
      languageCode: ''
    };
  }

  completarPaso(){
    if(this.pasoCompleto == false){
      let idiomasCompletos = true;
      if(this.surveyProduct.enableAudio == true){
        for (let clave in this.valoresForm) {
          if(this.valoresForm[clave].genero != "" && this.valoresForm[clave].tipoVoz != ""){

          } else{
            idiomasCompletos = false;
          }
        }
      } else idiomasCompletos = true;

      if(idiomasCompletos == true){
        if(this.surveyProduct.enableAudio == true){
          this.alertaRestric2(this.translateSrv.instant('VOICE.MODALES.COMPLETAR'),true);
        } else{
          this.alertaRestric2(this.translateSrv.instant('VOICE.MODALES.COMPLETAR_OFF'),true);
        }
      } else{
        this.alertaRestric2(this.translateSrv.instant('VOICE.MODALES.INCOMPLETO'),null,'warning');
      }
    } else{
      this.openSnackBar(this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO'),"OK");
    }
  }

  alertaRestric2(mensaje:string, confirmar?:boolean, tipo?:string){

    if(confirmar){
      Swal.fire({
        title: mensaje,
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          let datos:any={
              accionText:'',
              productoId:localStorage.getItem('productoID'),
              voice: 3,
              userAdministrator:'',
              actualizar: 1,
          }

          if(this.surveyProduct.enableAudio == true){
            this.updateWithAudios(datos);
          } else{
            this.completaPaso(datos);
          }
        }
      });
    }
    else{
      if(tipo == 'warning'){
        Swal.fire({
          icon: 'warning',
          title: mensaje,
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          confirmButtonColor: '#e40601'
        });
      }
      else if(tipo == 'success'){
        Swal.fire({
          icon: 'success',
          title: mensaje,
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          confirmButtonColor: '#e40601'
        });
      }
    }

  }

  updateWithAudios(datos:any){
    const datosUpdate = {
      surveyProductId: this.surveyProduct._id
    }
    Swal.fire({
      title: this.translateSrv.instant('VOICE.MODALES.GENERANDO_AUDIOS'),
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 60
    });
    this.confVozService.updateWithAudios(datosUpdate).subscribe((respuesta:any) => {
      console.log("updateWithAudios:",respuesta);
      if(respuesta.success){
        Swal.close();
        this.completaPaso(datos);
      }
    });
  }

  completaPaso(datos:any){
    this.confVozService.guardaStatusPaso(datos).subscribe( (data: any) => {
      if(data.message == '221'){
        this.openSnackBar(this.translateSrv.instant('VOICE.MODALES.PASO_COMPLETO'),"OK");
        this.pasoCompleto = true;
        this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
        this.surveyProductService.enviaDatosASurvProd({ actualizarProducto: true });
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

}
